import { useTranslation } from "react-i18next";

import type {
  IActionAlertVariantProps,
  IAlertButtonLoadingProps,
  IAlertButtonsType,
} from "@components/molecules/alert/types";
import { Button } from "@components/atoms/button";

export function DeleteAlertButtons(
  props: IAlertButtonsType<IActionAlertVariantProps> & IAlertButtonLoadingProps,
) {
  const {
    onClose,
    onCancel,
    cancelTitle,
    approveTitle,
    onApprove,
    isLoading,
    setIsLoading,
  } = props;
  const { t } = useTranslation("actions");

  return (
    <>
      <Button
        mode={"secondary"}
        onClick={() => {
          setIsLoading(false);
          if (onCancel) {
            onCancel();
          }
          onClose();
        }}
        disabled={isLoading}
      >
        {cancelTitle || t("cancel")}
      </Button>
      <Button
        mode={"danger-main"}
        isLoading={isLoading}
        onClick={async () => {
          setIsLoading(true);
          if (onApprove) {
            try {
              await onApprove();
            } catch {
              setIsLoading(false);
            }
          }
          onClose();
          setIsLoading(false);
        }}
      >
        {approveTitle || t("delete")}
      </Button>
    </>
  );
}
